import * as Sentry from "@sentry/react";


// Cấu hình Sentry với phiên bản tương thích
try {
  Sentry.init({
    dsn: "https://8b52bd20c7394d4bc3943bce37e18ccb@o4509438127243264.ingest.us.sentry.io/4509477979750400", //prod
    //dsn: "https://b868e31b4073891f524cd6ed2c1615ce@o4509438127243264.ingest.us.sentry.io/4509440464846849",//dev
    integrations: [Sentry.browserTracingIntegration()],
    // Thiết lập tỷ lệ giao dịch được ghi lại - 0.5 = 50%
    tracesSampleRate: 1.0,
    // Thiết lập môi trường
    environment: 'development',
    // Không gửi thông tin người dùng mặc định
    //defaultIntegrations: true,
    tracePropagationTargets: ["localhost", "https://dev.digiin.vn/api/", "https://digiin.vn/api/"],
  });
} catch (error) {
  console.error("Lỗi khởi tạo Sentry:", error);
}
